import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const buttonFn = /* @__PURE__ */ createRecipe('button', {
  "color": "primary",
  "variant": "solid",
  "size": "md",
  "responsive": false
}, [
  {
    "size": "md",
    "responsive": false,
    "css": {
      "textStyle": "labelLarge",
      "h": "auto",
      "py": 2,
      "px": 4,
      "gap": 2,
      "& svg": {
        "width": 5,
        "height": 5
      }
    }
  },
  {
    "size": "lg",
    "responsive": false,
    "css": {
      "textStyle": "labelLarge",
      "h": "auto",
      "py": 3,
      "px": 6,
      "gap": 2,
      "& svg": {
        "fontSize": "sm",
        "width": 5,
        "height": 5
      }
    }
  },
  {
    "size": "xl",
    "responsive": false,
    "css": {
      "textStyle": "labelExtraLarge",
      "h": "auto",
      "py": 4,
      "px": 8,
      "gap": 2.5,
      "& svg": {
        "fontSize": "md",
        "width": 5,
        "height": 5
      }
    }
  },
  {
    "size": "2xl",
    "responsive": false,
    "css": {
      "textStyle": "labelExtraLarge",
      "h": "auto",
      "py": 5,
      "px": 10,
      "gap": 3,
      "& svg": {
        "fontSize": "md",
        "width": 6,
        "height": 6
      }
    }
  },
  {
    "size": "md",
    "responsive": true,
    "css": {
      "textStyle": "labelMedium",
      "h": "auto",
      "py": 1,
      "px": 2,
      "gap": 2,
      "& svg": {
        "fontSize": "xs",
        "width": 2,
        "height": 2
      },
      "md": {
        "textStyle": "labelLarge",
        "h": "auto",
        "py": 2,
        "px": 4,
        "gap": 2,
        "& svg": {
          "width": 5,
          "height": 5
        }
      }
    }
  },
  {
    "size": "lg",
    "responsive": true,
    "css": {
      "textStyle": "labelMedium",
      "h": "auto",
      "py": 2,
      "px": 4,
      "gap": 2,
      "& svg": {
        "fontSize": "xs",
        "width": 4,
        "height": 4
      },
      "md": {
        "textStyle": "labelLarge",
        "h": "auto",
        "py": 3,
        "px": 6,
        "gap": 2,
        "& svg": {
          "fontSize": "sm",
          "width": 5,
          "height": 5
        }
      }
    }
  },
  {
    "size": "xl",
    "responsive": true,
    "css": {
      "textStyle": "labelLarge",
      "h": "auto",
      "py": 2,
      "px": 4,
      "gap": 2,
      "& svg": {
        "width": 5,
        "height": 5
      },
      "md": {
        "textStyle": "labelExtraLarge",
        "h": "auto",
        "py": 4,
        "px": 8,
        "gap": 2.5,
        "& svg": {
          "fontSize": "md",
          "width": 5,
          "height": 5
        }
      }
    }
  },
  {
    "size": "2xl",
    "responsive": true,
    "css": {
      "textStyle": "labelLarge",
      "h": "auto",
      "py": 3,
      "px": 6,
      "gap": 2,
      "& svg": {
        "fontSize": "sm",
        "width": 5,
        "height": 5
      },
      "md": {
        "textStyle": "labelExtraLarge",
        "h": "auto",
        "py": 5,
        "px": 10,
        "gap": 3,
        "& svg": {
          "fontSize": "md",
          "width": 6,
          "height": 6
        }
      }
    }
  }
])

const buttonVariantMap = {
  "color": [
    "primary",
    "secondary",
    "neutral",
    "success",
    "error"
  ],
  "variant": [
    "link",
    "subtle",
    "solid",
    "outline",
    "ghost"
  ],
  "size": [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
  ],
  "responsive": [
    "true",
    "false"
  ]
}

const buttonVariantKeys = Object.keys(buttonVariantMap)

export const button = /* @__PURE__ */ Object.assign(memo(buttonFn.recipeFn), {
  __recipe__: true,
  __name__: 'button',
  __getCompoundVariantCss__: buttonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: buttonVariantKeys,
  variantMap: buttonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, buttonVariantKeys)
  },
  getVariantProps: buttonFn.getVariantProps,
})